import { jsx } from "react/jsx-runtime";
import { ModalDialog } from "@zillow/constellation";
import { useState, useEffect } from "react";
import HubspotEmbed from "./HubspotEmbed.esm.js";
function HubspotPAFormModal() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(function addSyncOpenWithHashListenerOnMount() {
    function updateIsOpen() {
      if (window.location.hash === "#become-a-premier-agent-hs") {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    }
    window.addEventListener("hashchange", updateIsOpen);
    updateIsOpen();
    return () => {
      window.removeEventListener("hashchange", updateIsOpen);
    };
  }, []);
  return /* @__PURE__ */ jsx(ModalDialog, { isOpen, onClose: () => {
    history.pushState(null, "", location.href.substring(0, location.href.indexOf("#")));
    setIsOpen(false);
  }, renderHeader: null, dividers: false, scrollDocument: true, size: {
    default: ModalDialog.SIZES.FULL_SCREEN,
    md: ModalDialog.SIZES.LG
  }, renderBody: () => /* @__PURE__ */ jsx(HubspotEmbed, { region: "na1", portalId: "21555945", embedId: "188404409675", elementId: "hs-embed-188404409675-97z5ph" }) });
}
export {
  HubspotPAFormModal as default
};
